import { useState } from "react";
import CustomAccordion from "../Molecules/Accordian/CustomAccordion";
import {
  getSecureValidationReportPath,
  getSecureCrossFieldValidationReportPaths,
  downloadFileSecurely,
} from "../../services/fileDownloadService";
import { Box, CircularProgress } from "@mui/material";

const ResourceSupportDocuments = ({ title, documents }: any) => {
  const [downloadingFiles, setDownloadingFiles] = useState<Set<string>>(new Set());

  const handleSecureDownload = async (filepath: string, fileName: string) => {
    if (downloadingFiles.has(filepath)) return; // Prevent duplicate downloads

    setDownloadingFiles(prev => new Set(prev).add(filepath));

    try {
      await downloadFileSecurely(filepath, fileName);
    } catch (error) {
      console.error("Download failed:", error);
      // Error handling is done in the downloadFileSecurely function
      // which shows appropriate toast messages to the user
    } finally {
      setDownloadingFiles(prev => {
        const newSet = new Set(prev);
        newSet.delete(filepath);
        return newSet;
      });
    }
  };

  return (
    <CustomAccordion
      expandId="panel2d-header-support-documents"
      title={title}
      isEnabled={true}
      topMargin={8}
    >
      <table className="custom-table">
        <tbody>
          <tr>
            <th className="w-180">Report Type </th>
            <th>Report Location </th>
          </tr>
          <tr>
            <td>Validation Report</td>
            <td>
              {documents?.validation_report ? (
                (() => {
                  const { fileName } = getSecureValidationReportPath(documents.validation_report);
                  const isDownloading = downloadingFiles.has(documents.validation_report);

                  return (
                    <Box
                      sx={{
                        color: "text.primary",
                        cursor: isDownloading ? "not-allowed" : "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: 1
                      }}
                      onClick={() => !isDownloading && handleSecureDownload(documents.validation_report, fileName)}
                    >
                      {isDownloading && <CircularProgress size={16} />}
                      {fileName}
                    </Box>
                  );
                })()
              ) : (
                "N/A"
              )}
            </td>
          </tr>

          <tr>
            <td>Null Keys Report</td>
            <td>
              {documents?.null_keys_report ? (
                (() => {
                  const { fileName } = getSecureValidationReportPath(documents.null_keys_report);
                  const isDownloading = downloadingFiles.has(documents.null_keys_report);

                  return (
                    <Box
                      sx={{
                        color: "text.primary",
                        cursor: isDownloading ? "not-allowed" : "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: 1
                      }}
                      onClick={() => !isDownloading && handleSecureDownload(documents.null_keys_report, fileName)}
                    >
                      {isDownloading && <CircularProgress size={16} />}
                      {fileName}
                    </Box>
                  );
                })()
              ) : (
                "N/A"
              )}
            </td>
          </tr>
          <tr>
            <td>Filter Records Report</td>
            <td>
              {documents?.filter_records_report ? (
                (() => {
                  const { fileName } = getSecureValidationReportPath(documents.filter_records_report);
                  const isDownloading = downloadingFiles.has(documents.filter_records_report);

                  return (
                    <Box
                      sx={{
                        color: "text.primary",
                        cursor: isDownloading ? "not-allowed" : "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: 1
                      }}
                      onClick={() => !isDownloading && handleSecureDownload(documents.filter_records_report, fileName)}
                    >
                      {isDownloading && <CircularProgress size={16} />}
                      {fileName}
                    </Box>
                  );
                })()
              ) : (
                "N/A"
              )}
            </td>
          </tr>
          <tr>
            <td>Adhoc Query Reports</td>
            <td>
              {documents?.cross_field_validation_report_paths != null &&
              documents?.cross_field_validation_report_paths.length > 0
                ? documents?.cross_field_validation_report_paths.map(
                    (filterItem: string, index: number) => {
                      const { fileName } = getSecureCrossFieldValidationReportPaths(filterItem);
                      const isDownloading = downloadingFiles.has(filterItem);

                      return (
                        <Box key={index} className="word-break-all row-hr">
                          <Box
                            sx={{
                              color: "text.primary",
                              cursor: isDownloading ? "not-allowed" : "pointer",
                              display: "flex",
                              alignItems: "center",
                              gap: 1
                            }}
                            onClick={() => !isDownloading && handleSecureDownload(filterItem, fileName)}
                          >
                            {isDownloading && <CircularProgress size={16} />}
                            {fileName}
                          </Box>
                        </Box>
                      );
                    }
                  )
                : "N/A"}
            </td>
          </tr>
          <tr>
            <td>Output Logs</td>
            <td>
              {documents?.output_logs
                ? (() => {
                    const { fileName } = getSecureValidationReportPath(documents.output_logs);
                    const isDownloading = downloadingFiles.has(documents.output_logs);

                    return (
                      <Box
                        sx={{
                          color: "text.primary",
                          cursor: isDownloading ? "not-allowed" : "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: 1
                        }}
                        onClick={() => !isDownloading && handleSecureDownload(documents.output_logs, fileName)}
                      >
                        {isDownloading && <CircularProgress size={16} />}
                        {fileName}
                      </Box>
                    );
                  })()
                : "N/A"}
            </td>
          </tr>
        </tbody>
      </table>
    </CustomAccordion>
  );
};

export default ResourceSupportDocuments;